<template>
  <transition name="fade" appear>
    <div
      class="modal-overlay bg-white opacity-50 min-h-[100vh] max-w-[100vw] absolute left-0 right-0 bottom-0 top-0"
      v-show="showModal" @click.prevent="close()"></div>
  </transition>
  <transition name="pop" appear>
    <div class="modal absolute top-[70px] left-[50%] transform -translate-x-1/2 z-[99]" v-show="showModal"
      id="roadmap-page-block" role="dialog">
      <div id="login-dialog"
        class="dialog border border-[#E2E8F0] rounded-[8px] p-[20px] max-w-[670px] min-w-[670px] min-h-[460px] max-h-fit-content m-auto bg-white overflow-hidden text-center overflow-visible">
        <div>
          <div class="!relative overflow-hidden px-[40px] py-[30px]">
            <div @click="close"
              class="cursor-pointer close__btn absolute bg-[#ECF0FA] w-[32px] h-[32px] flex justify-center items-center rounded-[18px] right-[15px] top-[15px]">
            </div>
          </div>
          <div
            class="modal-body text-center flex flex-col max-w-full mx-auto text-left text-[#333] pt-0 m-0">
            <TitleComponent text="Login to your account"
              class="body__title font-montserrat-semibold text-[38px] leading-[45px] text-vip-black px-[96px] mb-[35px]" />
            <NodeUpdateForm mode="update" :nodeObj="nodeObj" @onSubmit="updateNode" ref="nodeForm" />            
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import TitleComponent from '@/components/common/TitleComponent.vue';
import NodeUpdateForm from '@/components/common/NodeUpdateForm.vue';

export default {
  emits: ['close', 'onSubmit'],
  name: 'UpdateNodeModal',
  components: {
    TitleComponent,
    NodeUpdateForm,
  },
  props: {
    showModal: {
      required: true,
      type: Boolean,
    },
    nodeObj: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    updateNode(node) {
      this.$emit('onSubmit', { chainName: node.chainName, decimalsCount: node.decimalsCount });
    },
    close() {
      setTimeout(() => {
        this.$emit('close');
      }, 100);
    },
  },
};
</script>

<style scoped>
* {
  font-family: 'Jost-Regular', sans-serif;
}
@media (max-width: 900px) {
  #login-dialog {
    max-width: 750px;
    min-width: 750px;
    height: 276px;
  }
}
@media (max-width: 790px) {
  #login-dialog  {
    max-width: 650px;
    min-width: 650px;
    height: 276px;
    gap: 20px;
    grid-template-columns: 1fr 3fr;
  }
  #login-dialog .image__container {
    width: 280px;
  }
  #login-dialog .close__btn {
    right: 30px;
  }
}
@media (max-width: 680px) {
  #login-dialog {
    max-width: 90vw !important;
    min-width: 90vw !important;
    margin: auto;
    height: fit-content;
  }
  .body__title {
    font-size: 40px;
    line-height: 35px;
    padding: 0;
    margin: 20px 0; 
  }
}
@media (max-width: 540px) {
  #login-dialog {
    max-width: 90vw !important;
    min-width: 90vw !important;
    margin: 0 auto !important;
    height: fit-content;
  }
  .body__title {
    font-size: 40px;
    line-height: 35px;
    padding: 0;
    margin-bottom: 20px;
  }
}
</style>
